import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { persistor, store } from "./redux/store";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { CanvasBackground } from "./components/CanvasBackground";
import { PersistGate } from "redux-persist/integration/react";
import { FooterBar } from "./components/FooterBar";
import { Placeholder } from "./app/pages/Placeholder";
import { ThemeSync } from "./components/ThemeSync";

const wip = true;

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <ThemeSync />
          <CanvasBackground />
          {wip ? <App /> : <Placeholder />}
          <footer>
            <FooterBar />
          </footer>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
